<template>
  <div class="main-layout">
    <!-- Tab导航组件 -->
    <TabNavigation />
    <!-- 子路由视图 -->
    <main class="content-area">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />
    </main>
  </div>
</template>

<script>
import TabNavigation from '../components/TabNavigation.vue'

export default {
  name: 'Layout',
  components: {
    TabNavigation
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.main-layout {
  width: 100%;
}

.content-area {
  padding-top: 78px;
  margin: 0 auto;
  width: 100%;
  position: relative;
}

/* 响应式调整 */
/* @media (max-width: 768px) {
  .content-area {
    padding: 15px 10px;
  }
} */
</style> 